<template>
  <div>
    <div class="invoice-box">
      <div class="up">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px">
          <el-form-item label="开票类型：" prop="type">
            <el-radio-group v-model="form.type" @change="changeType" :disabled="invoiceFlag">
              <el-radio :label="0" border>企业</el-radio>
              <el-radio :label="1" border>个人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="真实姓名：" v-if="form.type == 1" prop="title">
            <el-input
              v-model="form.title"
              placeholder="请正确填写您的姓名"
              maxlength="255"
              :disabled="invoiceFlag"
            ></el-input>
          </el-form-item>
          <el-form-item label="发票抬头：" v-if="form.type == 0" prop="title">
            <el-input
              v-model="form.title"
              placeholder="请正确填写公司名称"
              maxlength="255"
              :disabled="invoiceFlag"
            ></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号：" v-if="form.type == 0" prop="identifyNum">
            <el-input
              v-model="form.identifyNum"
              placeholder="纳税人识别号统一信用码"
              maxlength="100"
              :disabled="invoiceFlag"
            ></el-input>
          </el-form-item>
          <div style="margin-top: 30px">
            <el-form-item label="收件人：" prop="receiverName">
              <el-input
                v-model="form.receiverName"
                placeholder="请正确填写姓名"
                maxlength="100"
                :disabled="invoiceFlag"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="收件人手机号：" prop="receiverPhone">
            <el-input
              v-model="form.receiverPhone"
              placeholder="请确保手机号码准确"
              maxlength="50"
              :disabled="invoiceFlag"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人邮箱：" prop="receiverEmail">
            <el-input
              v-model="form.receiverEmail"
              placeholder="请正确填写邮箱"
              maxlength="100"
              :disabled="isInvoiceFlag"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件地址：" prop="receiverAddress">
            <el-input
              type="textarea"
              v-model="form.receiverAddress"
              placeholder="请填写您的详细地址"
              resize="none"
              rows="4"
              maxlength="500"
              show-word-limit
              :disabled="invoiceFlag"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="form.remark" maxlength="255" :disabled="invoiceFlag"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              style="background: #fad680; color: #8a6a1b; border-color: #fad680;"
              :disabled="invoiceFlag"
            >提交</el-button>
            <el-button style="color: #aaaaaa" @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class='tip'>
          发票信息提供后，我们将于7个工作日内为您寄出，前往发票列表可查看开票进度
      </div>-->
      <div class="contact">客服电话：010-65185898 | +86 15210925572</div>
    </div>
  </div>
</template>

<script>
import { openInvoice, getInvoiceDetail } from "@/api/product";
export default {
  data() {
    var validateTel = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("请正确输入手机号"));
      }
      callback();
    };
    return {
      form: {
        type: "0",
        title: "",
        identifyNum: "",
        receiverName: "",
        receiverPhone: "",
        receiverEmail: "",
        receiverAddress: "",
        remark: ""
      },
      rules: {
        type: [
          { required: true, message: "请输入发票类型", trigger: "change" }
        ],
        title: [
          {
            required: true,
            message: "请输入发票抬头/真实姓名",
            trigger: "blur"
          }
        ],
        identifyNum: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" }
        ],
        receiverName: [
          { required: true, message: "请输入收件人", trigger: "blur" }
        ],
        receiverPhone: [
          { required: true, validator: validateTel, trigger: "blur" }
        ],
        receiverEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" }
        ],
        receiverAddress: [
          { required: true, message: "请输入收件地址", trigger: "blur" }
        ]
      }
    };
  },
  components: {},
  created() {
    this.handleGetInvoiceDetail();
  },
  props: ["orderNo", "invoiceFlag"],
  methods: {
    async handleGetInvoiceDetail() {
      if (this.invoiceFlag) {
        let params = {
          orderNo: this.orderNo
        };
        let { data } = await getInvoiceDetail(params);
        if (data.resultCode == "200") {
          this.form = data.resultBody;
        }
      } else {
        this.form = {
          type: 0,
          title: "",
          identifyNum: "",
          receiverName: "",
          receiverPhone: "",
          receiverAddress: "",
          receiverEmail: "",
          remark: ""
        };
      }
    },
    changeType(val) {
      this.form = {
        type: val,
        title: "",
        identifyNum: "",
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        receiverEmail: "",
        remark: ""
      };
      this.$refs.form && this.$refs.form.resetFields();
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let params = {
            orderNo: this.orderNo,
            ...this.form
          };
          let { data } = await openInvoice(params);
          if (data.resultCode == "200") {
            this.$message.success("提交成功");
            this.cancel();
          }
        }
      });
    },
    cancel() {
      this.$emit("hideInvoiceDialog", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-box {
  text-align: center;
  .up {
    margin: 0 30px;
    text-align: left;
    padding: 30px 20%;
    .el-radio {
      margin-right: 0;
    }
    /deep/ .el-radio__inner {
      display: none;
    }
    /deep/ .el-radio.is-bordered {
      width: 68px;
      height: 22px;
      line-height: 0;
      padding-top: 9px;
    }
    /deep/ .el-radio__label {
      font-size: 12px;
    }
    /deep/ .el-radio.is-bordered.is-checked {
      border-color: #f77752;
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #f77752;
    }
    .el-form-item {
      margin-bottom: 14px;
    }
    /deep/ .el-form-item__label {
      font-size: 12px;
    }
    /deep/ .el-form-item__error {
      padding-top: 0;
    }
    /deep/ .el-input__inner {
      height: 26px;
      font-size: 12px;
    }
    /deep/ .el-textarea__inner {
      font-size: 12px;
      font-family: Arial;
    }
    .el-button {
      width: 130px;
      height: 26px;
      line-height: 0;
      font-size: 12px;
    }
  }
  .contact {
    margin-top: 30px;
    font-size: 12px;
  }
}
</style>